export default class User {
  constructor(username, email, password, repassword) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.repassword = repassword;
  }
}
